import React, { useRef, useState } from 'react';
import firebaseConfig from '../config';
import 'firebase/compat/database';
import anim from '../assets/contact-anim.gif';

function Contact() {

    const contactDb = firebaseConfig.database().ref('contact');
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [title, setTitle] = useState('')
    const [text, setText] = useState('')
    const nameRef = useRef('')
    const emailRef = useRef('')
    const titleRef = useRef('')
    const textRef = useRef('')

    const submitContact = () => {
        // console.log({
        //     name: name,
        //     email: email,
        //     title: title,
        //     text: text
        // })
        contactDb.push({
            name: name,
            email: email,
            title: title,
            text: text
        })
    }
    return (
        <div className="bg-con" id="contact">
            <div className="max-con">
                <h2>Contact</h2>
                <div className="contact-flex">
                    <div>
                        <img style={{width: '100%'}} src={anim} alt=""/>
                    </div>
                    <div className="input-contact">
                        <label for="name">Name:</label>
                        <input type="text" name="name" className="form-control" ref={nameRef} value={name} onChange={e => setName(e.target.value)}/>
                        <br/>
                        <br/>
                        <label for="email">Email:</label>
                        <input type="email" name="email" className="form-control" ref={emailRef} value={email} onChange={e => setEmail(e.target.value)}/>
                        <br/>
                        <br/>
                        <label for="title">Title:</label>
                        <input type="text" name="title" className="form-control" ref={titleRef} value={title} onChange={e => setTitle(e.target.value)}/>
                        <br/>
                        <br/>
                        <label for="text">Text:</label>
                        <textarea type="text" name="text" rows="4" className="form-control" ref={textRef} value={text} onChange={e => setText(e.target.value)}/>
                        <br/>
                        <br/>
                        <div style={{textAlign: 'center'}}>
                            <button className="btn-submit" onClick={submitContact}>Send</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contact
